import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Telehealth = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="telehealth icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0.981934C5.79086 0.981934 4 2.7728 4 4.98193V20.9819C4 23.1911 5.79086 24.9819 8 24.9819H16C18.2091 24.9819 20 23.1911 20 20.9819V4.98193C20 2.77279 18.2091 0.981934 16 0.981934H8ZM7 4.98193C6.44772 4.98193 6 5.42965 6 5.98193V18.8723C7.2249 16.8395 9.45367 15.4799 12 15.4799C14.5463 15.4799 16.7751 16.8395 18 18.8723V5.98193C18 5.42965 17.5523 4.98193 17 4.98193H7ZM16.7717 20.9819C16.1352 18.9523 14.2396 17.4799 12 17.4799C9.76044 17.4799 7.86478 18.9523 7.22827 20.9819H16.7717ZM10 22.9819C10 22.4296 10.4477 21.9819 11 21.9819H13C13.5523 21.9819 14 22.4296 14 22.9819C14 23.5342 13.5523 23.9819 13 23.9819H11C10.4477 23.9819 10 23.5342 10 22.9819ZM8 9.98193C8 7.77279 9.79086 5.98193 12 5.98193C14.2091 5.98193 16 7.77279 16 9.98193V10.9819C16 13.1911 14.2091 14.9819 12 14.9819C9.79086 14.9819 8 13.1911 8 10.9819V9.98193ZM12 7.98193C10.8954 7.98193 10 8.87736 10 9.98193V10.9819C10 12.0865 10.8954 12.9819 12 12.9819C13.1046 12.9819 14 12.0865 14 10.9819V9.98193C14 8.87736 13.1046 7.98193 12 7.98193Z"
    />
  </svg>
)
